import { render, staticRenderFns } from "./CargoDetails.vue?vue&type=template&id=b8a74154"
import script from "./CargoDetails.vue?vue&type=script&lang=js"
export * from "./CargoDetails.vue?vue&type=script&lang=js"
import style0 from "./CargoDetails.vue?vue&type=style&index=0&id=b8a74154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports